import axios from "axios";
import configProxy from "../utils/config";

export const taApiClient = axios.create({
    baseURL: configProxy.api_url
});

export default axios;
